// extracted by mini-css-extract-plugin
export var container = "_fo-0";
export var icon = "_fo-1";
export var text = "_fo-2";